import {
  Component,
  OnInit,
} from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { errorDescriptionsMap } from 'src/app/shared/utils';

@Component({
  selector: 'app-healthpicks-operator-login',
  templateUrl: './healthpicks-operator-login.component.html',
  styleUrls: ['../style/global.css', './healthpicks-operator-login.component.css'],
})
export class HealthpicksOperatorLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  private static readonly emailFormatRe =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?(?:\.[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?)+$/;

  async init(): Promise<void> {}

  isLoginInfoInput(): boolean {
    if (!super.isLoginInfoInput()) {
      return false;
    }
    const emailTrimmed = this.email.trim();
    if (!emailTrimmed) {
      this.errorMessages.login.email = 'メールアドレスを入力してください。';
      this.errorMessages.login.password = this.password
        ? ''
        : 'パスワードを入力してください';
      return false;
    }
    if (!HealthpicksOperatorLoginComponent.emailFormatRe.test(emailTrimmed)) {
      this.errorMessages.login.email =
        'メールアドレスまたはパスワードを確認してください。';
      this.errorMessages.login.password = '';
      return false;
    }
    this.email = emailTrimmed;
    return true;
  }

  get isMedicalUser() {
    return this.role !== 'patient';
  }

  get isOem() {
    return false; // update if needed
  }

  get isRegisterResendable(): boolean {
    return true;
  }

  get isRegistable() {
    return false; // usually false in operator
  }

  protected get errorDescripitionsMap() {
    return {
      ...errorDescriptionsMap,
      'Wrong email or password.': 'メールアドレスまたはパスワードを確認してください。',
      "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.": 'このアカウントはロックまたは無効化されています。管理者にお問い合わせください。',
      "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.": 'このアカウントはロックまたは無効化されています。管理者にお問い合わせください。'
    };
  }
}
